<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <span style="display: inline-block;color: #48576a;font-size: 0.0875rem;line-height: 30px;margin-right: 5px;">合同结束日期</span>
        <el-date-picker v-model="timevalue" size="small" type="daterange" style="width: 280px;"
                        :picker-options="pickerOptions2" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <input-select selectTitle="合同状态" :selectKey="'status'" :selectData="statusList" @search="search"/>
      <div style="display: flex;justify-content: flex-end;align-items: center;">
        <input-search placeholder="住户名称/租赁地址" @search="searchKey" style="margin-right: 10px;" />
        <button-export
          :href="exportUrl"
          download="download.xls"
          :beforeDownload="beforeDownload"
          value="导出"/>
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @toCurrentPage="toCurrentPage" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="operationArr" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/InvestmentLeasing'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nAlert, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'contract-management',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧合约',
          name: 'investment-over-view'
        }, {
          value: '归档合同'
        }],
        pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        statusList: [
          {
            key: '',
            label: '全部'
          }, {
            key: '9',
            label: '已作废'
          }, {
            key: '14',
            label: '已退租'
          }, {
            key: '19',
            label: '已换租'
          }
        ],
        tableHead: [
          {prop: 'code', label: '合同编号'},
          {prop: "leaseName", label: "承租主体"},
          {prop: "roomInfoName", label: "租赁地址"},
          {prop: 'contractSignDate', label: '合同签订日期'},
          {prop: 'contractStartDate', label: '合同开始日期'},
          {prop: 'contractEndDate', label: '合同结束日期'},
          {prop: 'statusText', label: '合同状态', showColor3: true},
          {prop: 'fellowPeopleName', label: '跟进人', width: '100'},
          {prop: 'signerName', label: '签订人', width: '100'}
        ],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        exportUrl: '',
        uploadUrl: '',
        selectionArr: [],
        timevalue: [],
        requestData: {
          searchKey: '',
          status: '',
          startTime: '',
          endTime: ''
        },
        operationArr: ['current']
      }
    },
    created () {
      this.uploadUrl = api.importContract
      this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    activated() {
      this.getPage()
    },
    methods: {
      beforeDownload () {
        this.exportUrl = `${api.exportContract}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&pigeonhole=1&searchKey=${this.requestData.searchKey}&status=${this.requestData.status}&startTime=${this.requestData.startTime}&endTime=${this.requestData.endTime}`
      },
      getPage () {
        if (this.timevalue) {
          this.requestData.startTime = this.timevalue[0] || ''
          this.requestData.endTime = this.timevalue[1] || ''
        } else {
          this.requestData.startTime = ''
          this.requestData.endTime = ''
        }
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        reqData.pigeonhole = '1'
        this.$axios.post(api.getContractPage, reqData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {
                if (v.customIntendType === '0') {
                  v.customIntendTypeText = '未分类'
                } else if (v.customIntendType === '1') {
                  v.customIntendTypeText = '潜在客户'
                } else if (v.customIntendType === '2') {
                  v.customIntendTypeText = '意向客户'
                } else if (v.customIntendType === '3') {
                  v.customIntendTypeText = '成交客户'
                } else if (v.customIntendType === '4') {
                  v.customIntendTypeText = '流失客户'
                }
                if (v.status === "1") {
                  v.statusText = "新建待确认";
                  v.fontColorToPeople3 = "#8B36EF";
                  v.backgroundColor3 = "#F1E8FC";
                } else if (v.status === "2") {
                  v.statusText = "续租待确认";
                  v.fontColorToPeople3 = "#8B36EF";
                  v.backgroundColor3 = "#F1E8FC";
                } else if (v.status === "3") {
                  v.statusText = "退租待确认";
                  v.fontColorToPeople3 = "#8B36EF";
                  v.backgroundColor3 = "#F1E8FC";
                } else if (v.status === "4") {
                  v.statusText = "新建待审批";
                  v.fontColorToPeople3 = "#1362FF";
                  v.backgroundColor3 = "#EAF0FF";
                } else if (v.status === "5") {
                  v.statusText = "续租待审批";
                  v.fontColorToPeople3 = "#1362FF";
                  v.backgroundColor3 = "#EAF0FF";
                } else if (v.status === "6") {
                  v.statusText = "退租待审批";
                  v.fontColorToPeople3 = "#1362FF";
                  v.backgroundColor3 = "#EAF0FF";
                } else if (v.status === "7") {
                  v.statusText = "正常执行";
                  v.fontColorToPeople3 = "#50B5FF";
                  v.backgroundColor3 = "#EAF5FF";
                } else if (v.status === "8") {
                  v.statusText = "到期未处理";
                  v.fontColorToPeople3 = "#FC5A5A";
                  v.backgroundColor3 = "#FAEDED";
                } else if (v.status === "9") {
                  v.statusText = "已作废";
                  v.fontColorToPeople3 = "#8B36EF";
                  v.backgroundColor3 = "#F1E8FC";
                } else if (v.status === "10") {
                  v.statusText = "已归档";
                  v.fontColorToPeople3 = "#18887B";
                  v.backgroundColor3 = "#E4F0EF";
                } else if (v.status === "11") {
                  v.statusText = "续租待执行";
                  v.fontColorToPeople3 = "#F29324";
                  v.backgroundColor3 = "#FDF3E7";
                } else if (v.status === "12") {
                  v.statusText = "退租待执行";
                  v.fontColorToPeople3 = "#F29324";
                  v.backgroundColor3 = "#FDF3E7";
                } else if (v.status === "13") {
                  v.statusText = "到期已处理";
                  v.fontColorToPeople3 = "#18887B";
                  v.backgroundColor3 = "#E4F0EF";
                } else if (v.status === "14") {
                  v.statusText = "已退租";
                  v.fontColorToPeople3 = "#18887B";
                  v.backgroundColor3 = "#E4F0EF";
                } else if (v.status === "15") {
                  v.statusText = "作废待审批";
                  v.fontColorToPeople3 = "#1362FF";
                  v.backgroundColor3 = "#EAF0FF";
                } else if (v.status === "16") {
                  v.statusText = "换租待确认";
                  v.fontColorToPeople3 = "#8B36EF";
                  v.backgroundColor3 = "#F1E8FC";
                } else if (v.status === "17") {
                  v.statusText = "换租待审批";
                  v.fontColorToPeople3 = "#1362FF";
                  v.backgroundColor3 = "#EAF0FF";
                } else if (v.status === "18") {
                  v.statusText = "换租待执行";
                  v.fontColorToPeople3 = "#F29324";
                  v.backgroundColor3 = "#FDF3E7";
                } else if (v.status === "19") {
                  v.statusText = "已换租";
                  v.fontColorToPeople3 = "#18887B";
                  v.backgroundColor3 = "#E4F0EF";
                }
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取合同信息失败'))
      },
      search (v) {
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      toCurrentPage (code) {
        this.$router.push({
          path: `/filing_contract_current/${code}`
        })
      },
    },
    watch: {
      timevalue (val) {
        this.getPage()
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
  .btn-box {
    .el-date-editor .el-range-separator {
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/InvestmentLeasing/ContractManagement/FilingContract.vue